import { Skeleton } from "@/components/ui/skeleton";

// Mirrors PublicMicrosite: full-bleed 12-col hero with an image panel, then the
// progress section with its oversized percentage numeral and phase tracker.
// Uses the public linen/bone/edge palette, not the dashboard dash-* tokens.
export default function PublicMicrositeSkeleton() {
  return (
    <div className="min-h-screen bg-linen" role="status" aria-label="Loading update">
      <section className="relative">
        <div className="grid min-h-[80vh] border-b border-edge lg:min-h-screen lg:grid-cols-12">
          <div className="order-2 flex flex-col justify-center p-8 lg:order-1 lg:col-span-7 lg:p-20">
            <Skeleton className="h-3 w-56 bg-ink/5" />
            <Skeleton className="mt-6 h-[clamp(2.5rem,6vw,5rem)] w-full max-w-2xl bg-ink/5" />
            <Skeleton className="mt-4 h-[clamp(2rem,4vw,3.5rem)] w-3/5 max-w-xl bg-ink/5" />
            <div className="mt-8 max-w-xl space-y-3">
              <Skeleton className="h-4 w-full bg-ink/5" />
              <Skeleton className="h-4 w-4/5 bg-ink/5" />
            </div>
            <Skeleton className="mt-12 h-4 w-44 bg-ink/5" />
          </div>
          <div className="order-1 min-h-[280px] bg-bone lg:order-2 lg:col-span-5 lg:min-h-screen" />
        </div>
      </section>

      <section className="mx-auto max-w-[1100px] px-6 py-24 lg:px-12">
        <Skeleton className="h-3 w-32 bg-ink/5" />
        <div className="mt-4 grid items-end gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Skeleton className="h-12 w-72 max-w-full bg-ink/5" />
            <Skeleton className="mt-4 h-4 w-48 bg-ink/5" />
          </div>
          <div className="flex justify-end lg:col-span-5">
            <Skeleton className="h-20 w-32 bg-ink/5" />
          </div>
        </div>
        <Skeleton className="mt-10 h-2 w-full rounded-none bg-bone" />

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {[0, 1, 2, 3].map((phase) => (
            <div key={phase} className="border-t border-edge pt-4">
              <Skeleton className="h-3 w-16 bg-ink/5" />
              <Skeleton className="mt-3 h-5 w-28 bg-ink/5" />
            </div>
          ))}
        </div>
      </section>
      <span className="sr-only">Loading this update…</span>
    </div>
  );
}
